
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.977 2.5c1.462 0 2.442 1.11 2.518 2.21l.005.138V5.5H14a2.5 2.5 0 012.495 2.336L16.5 8v6a2.5 2.5 0 01-2.336 2.495L14 16.5H6a2.5 2.5 0 01-2.495-2.336L3.5 14V8a2.5 2.5 0 012.336-2.495L6 5.5h1.5v-.652c0-1.11.878-2.253 2.296-2.342l.18-.006zM14 6.5H6a1.5 1.5 0 00-1.493 1.356L4.5 8v6a1.5 1.5 0 001.356 1.493L6 15.5h8a1.5 1.5 0 001.493-1.355L15.5 14V8a1.5 1.5 0 00-1.355-1.493L14 6.5zM10 9a2 2 0 110 4 2 2 0 010-4zm0 1a1 1 0 100 2 1 1 0 000-2zm-.023-6.5c-.863 0-1.41.62-1.471 1.233l-.006.115V5.5h3v-.652c0-.554-.466-1.18-1.21-1.32l-.154-.02-.16-.008z","fill":"#222"}})])
          )
        }
      }
    